import '../stylesheets/Contact.css';
import Form from '../Form.jsx';
import {BrowserView, MobileView} from 'react-device-detect';
//import { useEffect } from 'react';

export const Contact = () => {
  return (

    <div className= "body">
      <BrowserView>
        <h2 className="subhead" id="first">Contact</h2>
        <p className="paragraph"><span className='exclaim'>We want to collaborate with you!</span> <br/>Whether a quote for work or more information about our services, please enter your contact details below.</p>
        <div>
          <Form/>
        </div>
      </BrowserView>
      <MobileView>
        <h2 className="mobileSubhead" id="first">Contact</h2>
        <p className="mobileParagraph"><span className='mobileExclaim'>We want to collaborate with you!</span> <br/>Whether a quote for work or more information about our services, please enter your contact details below.</p>
        <div className='mobileForm'>
          <Form/>
        </div>
      </MobileView>
    </div>
        
  )
}

// function Contact() {

//   useEffect(()=> {
//     fetch('http://localhost:8081/users')
//     .then(res => res.json())
//     .then(data => console.log(data))
//     .catch(err => console.log(err));
//   }, [])

//   return (
//     <div className='body'>
//       <Form/>
//     </div>
//   )
// }


// export default Contact;

